<div *ngIf="value != null && programSourceId === programSourceTypes.default" class="field row">
    <label class="field-label" for="factory-rebate" translate="factoryRebateLabel"></label>
    <span class="field-data" id="factory-rebate">{{value | localeCurrency}}</span>
</div>